<app-tab-layout [loading]="loading()" [error]="error">
  @if(initialized()){
  <app-api-table [name]="name" [endpoint]="'/products/tables'" [hasIndexCol]="true" [hasChartView]="false"
    [onRowClick]="onProductRowClick"></app-api-table>
  }
</app-tab-layout>